import { render, staticRenderFns } from "./CooperationInfoFee.vue?vue&type=template&id=23d3f8ad&scoped=true"
import script from "./CooperationInfoFee.vue?vue&type=script&lang=js"
export * from "./CooperationInfoFee.vue?vue&type=script&lang=js"
import style0 from "./CooperationInfoFee.vue?vue&type=style&index=0&id=23d3f8ad&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d3f8ad",
  null
  
)

export default component.exports